import createIcon from '../../createIcon';

/**
 * @component @name Face3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4wMDQ0NiAxMy4yNUM5LjY5NDgxIDEzLjI1IDEwLjI1NDUgMTIuNjkwNCAxMC4yNTQ1IDEyQzEwLjI1NDUgMTEuMzA5NiA5LjY5NDgxIDEwLjc1IDkuMDA0NDYgMTAuNzVDOC4zMTQxIDEwLjc1IDcuNzU0NDYgMTEuMzA5NiA3Ljc1NDQ2IDEyQzcuNzU0NDYgMTIuNjkwNCA4LjMxNDEgMTMuMjUgOS4wMDQ0NiAxMy4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNS4wMDQ1IDEzLjI1QzE1LjY5NDggMTMuMjUgMTYuMjU0NSAxMi42OTA0IDE2LjI1NDUgMTJDMTYuMjU0NSAxMS4zMDk2IDE1LjY5NDggMTAuNzUgMTUuMDA0NSAxMC43NUMxNC4zMTQxIDEwLjc1IDEzLjc1NDUgMTEuMzA5NiAxMy43NTQ1IDEyQzEzLjc1NDUgMTIuNjkwNCAxNC4zMTQxIDEzLjI1IDE1LjAwNDUgMTMuMjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIuOTE0NSAxMC45NkMyMi4zOTQ1IDUuMzIgMTcuNjY0NSAxIDEyLjAwNDUgMUM2LjM0NDQ2IDEgMS42MTQ0NiA1LjMyIDEuMDk0NDYgMTAuOTZMMC4xOTQ0NTcgMjAuODJDMC4wOTQ0NTY3IDIxLjk5IDEuMDE0NDYgMjMgMi4xOTQ0NiAyM0gyMS44MTQ1QzIyLjk5NDUgMjMgMjMuOTE0NSAyMS45OSAyMy44MDQ1IDIwLjgyTDIyLjkxNDUgMTAuOTZaTTQuNTQ0NDYgOC4xM0M1LjQxNDQ2IDguNjggNi40MzQ0NiA5IDcuNTA0NDYgOUM5LjM2NDQ2IDkgMTEuMDA0NSA4LjA3IDEyLjAwNDUgNi42NUMxMy4wMDQ1IDguMDcgMTQuNjQ0NSA5IDE2LjUwNDUgOUMxNy41NzQ1IDkgMTguNTk0NSA4LjY4IDE5LjQ2NDUgOC4xM0MxOS44MDQ1IDkuMDIgMjAuMDA0NSA5Ljk5IDIwLjAwNDUgMTFDMjAuMDA0NSAxNS40MSAxNi40MTQ1IDE5IDEyLjAwNDUgMTlDNy41OTQ0NiAxOSA0LjAwNDQ2IDE1LjQxIDQuMDA0NDYgMTFDNC4wMDQ0NiA5Ljk5IDQuMjA0NDYgOS4wMiA0LjU0NDQ2IDguMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Face3 = createIcon('Face3', [
  [
    'path',
    {
      d: 'M9.00446 13.25C9.69481 13.25 10.2545 12.6904 10.2545 12C10.2545 11.3096 9.69481 10.75 9.00446 10.75C8.3141 10.75 7.75446 11.3096 7.75446 12C7.75446 12.6904 8.3141 13.25 9.00446 13.25Z',
      key: '1fzci8',
    },
  ],
  [
    'path',
    {
      d: 'M15.0045 13.25C15.6948 13.25 16.2545 12.6904 16.2545 12C16.2545 11.3096 15.6948 10.75 15.0045 10.75C14.3141 10.75 13.7545 11.3096 13.7545 12C13.7545 12.6904 14.3141 13.25 15.0045 13.25Z',
      key: 'pgkyz9',
    },
  ],
  [
    'path',
    {
      d: 'M22.9145 10.96C22.3945 5.32 17.6645 1 12.0045 1C6.34446 1 1.61446 5.32 1.09446 10.96L0.194457 20.82C0.0944567 21.99 1.01446 23 2.19446 23H21.8145C22.9945 23 23.9145 21.99 23.8045 20.82L22.9145 10.96ZM4.54446 8.13C5.41446 8.68 6.43446 9 7.50446 9C9.36446 9 11.0045 8.07 12.0045 6.65C13.0045 8.07 14.6445 9 16.5045 9C17.5745 9 18.5945 8.68 19.4645 8.13C19.8045 9.02 20.0045 9.99 20.0045 11C20.0045 15.41 16.4145 19 12.0045 19C7.59446 19 4.00446 15.41 4.00446 11C4.00446 9.99 4.20446 9.02 4.54446 8.13Z',
      key: '1qyeu9',
    },
  ],
]);

export default Face3;
